import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getAccessList = async (offset, itemsPerPage, activePage, params) => {
  const response = await agent.get(
    `${API_URL}channel-access/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

const getUserOptions = async (search = '') => {
  const response = await agent.get(`${API_URL}channel-access/user-options`, {
    params: { search },
  })
  return response.data
}

const grantAccess = async (data) => {
  const response = await agent.post(API_URL + 'channel-access/grant', data)
  return response.data
}

const revokeAccess = async (data) => {
  const response = await agent.post(API_URL + 'channel-access/revoke', data)
  return response.data
}

const ChannelAccessService = {
  getAccessList,
  getUserOptions,
  grantAccess,
  revokeAccess,
}

export default ChannelAccessService
